










































import { Component, Prop, Vue } from 'vue-property-decorator'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'

@Component({
  name: 'PickupCorporatePhoneCell',
  components: {
    EyeIcon,
    EyeDisabledIcon
  }
})
class PickupCorporatePhoneCell extends Vue {
  @Prop({ type: String, required: true })
  readonly shipmentId!: string

  @Prop({ type: String, required: true, default: '-' })
  readonly phoneMaskedDisplay!: string

  @Prop({ type: String, default: null })
  readonly phonePlainDisplay!: string | null

  @Prop({ type: Boolean, required: true, default: false })
  readonly isRevealed!: boolean

  @Prop({ type: Boolean, default: false })
  readonly isRevealLoading!: boolean

  get isPhoneEmpty(): boolean {
    return (
      !this.phoneMaskedDisplay ||
      this.phoneMaskedDisplay === '-' ||
      this.phoneMaskedDisplay.trim() === ''
    )
  }

  handleToggle(): void {
    if (this.isRevealed) {
      this.$emit('hide-phone', { shipmentId: this.shipmentId })
    } else {
      this.$emit('reveal-phone', { shipmentId: this.shipmentId })
    }
  }
}

export default PickupCorporatePhoneCell
